import type { MouseEvent } from "react";
import { FC } from "react";
import { Button, Spinner } from "react-bootstrap";

import { CustomModal } from "./";

interface IProps {
  onSubmit: (e: MouseEvent<HTMLButtonElement>) => void;
  onCancel: () => void;
  visible: boolean;
  title?: string;
  text?: React.ReactNode;
  okText?: string;
  cancelText?: string;
  data?: any;
  isProcessing?: boolean;
  displayError?: string;
}

const ConfirmModal: React.FC<IProps> = ({
  onSubmit,
  onCancel,
  visible,
  title = "",
  text = "",
  okText = "Ok",
  cancelText = "Cancel",
  data,
  isProcessing,
  displayError,
}) => {
  const handleCancelClick = () => {
    onCancel();
  };

  const handleOkClick = () => {
    onSubmit(data);
  };

  const footerButtons = () => {
    return (
      <>
        <Button
          className="btn btn-sm"
          size="sm"
          variant="secondary"
          onClick={handleCancelClick}
        >
          {cancelText}
        </Button>
        <Button
          size="sm"
          className="flex-shrink-0"
          type="submit"
          variant="danger"
          onClick={handleOkClick}
          disabled={isProcessing || !!displayError}
          data-testid="delete-item"
        >
          {okText}
          {isProcessing && (
            <Spinner className="ms-2" size="sm" animation="border" />
          )}
        </Button>
      </>
    );
  };

  return (
    <CustomModal
      show={visible}
      handleClose={onCancel}
      title={title}
      footer={footerButtons()}
      errorMessage={displayError}
    >
      <div>{text}</div>
    </CustomModal>
  );
};

export { ConfirmModal };
